import { PREFIX_URL } from '@/src/api/config';

export const PROJECT_BASE_URL = `${PREFIX_URL}/projects/:projectId`;
